
export const LEAGUES = {
  country1: [
    {league1a: {name: 'Premiership'}}, {league2a: {name: 'Championship'}}, {league3a: {name: 'Fa Cup'}}, 
    {league4a: {name: 'League One'}}, {league5a: {name: 'League Two'}}, {league6a: {name: 'National League'}}, 
    {league7a: {name: 'National League North'}}, {league8a: {name: 'National League South'}}, 
    {league9a: {name: 'Professional Development League'}}, 
  ], 
  country2: [
    {league1b: {name: 'Ligue 1'}}, {league2b: {name: 'National'}}, {league3b: {name: 'Championnat National 19'}},
  ],
  country3: [
    {league1c: {name: 'Bundesliga'}}, {league2c: {name: '2. Bundesliga'}}, 
    {league3c: {name: 'Bayernliga South'}}, {league4c: {name: 'Bayernliga North'}}, 
    {league5c: {name: 'Bremen-Liga'}}, {league6c: {name: 'Hesenliga'}},
    {league7c: {name: 'Oberliga Mittelrhein'}}, {league8c: {name: 'Oberliga Niederrhein'}}, 
    {league9c: {name: 'Oberliga HamBurg'}}, {league10c: {name: 'Oberliga Bavaria1'}}, 
    {league11c: {name: 'Regionliga Bavaria2'}}, {league12c: {name: 'Regionliga Bavaria3'}},
    {league13c: {name: 'Regionliga Bavaria4'}}, {league14c: {name: 'Regionliga Bavaria5'}}, 
    {league15c: {name: 'Regionliga Bavaria6'}}, {league16c: {name: 'Oberliga Baden-Wuertternberg'}}, 
    {league17c: {name: 'Oberliga NOFV North'}}, {league18c: {name: 'Oberliga NOFV South'}},
  ],
  country4: [
    {league1d: {name: 'Serie A'}}, {league2d: {name: 'Serie B'}}, {league3d: {name: 'Serie c'}}, 
    {league4d: {name: 'Serie D'}},{league5d: {name: 'Compionato Primavera'}},
  ],
  country5: [
    {league1e: {name: 'LaLiga'}}, {league2e: {name: 'LaLiga 2'}}, {league3e: {name: 'Copa Del Rey'}},
    {league4e: {name: 'Primera RFEF'}}, {league5e: {name: 'Primera Division Femina'}}
  ]
}
